import React, { ReactElement } from 'react';

const Presentation: React.FC = (): ReactElement => {
  return (
    <div className="text-dark w-full flex flex-col justify-center items-center">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Presentation.jpg"
          className=" min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
        <div className="px-8 sm:p-0 text-light text-lg md:text-xl lg:text-2xl absolute max-w-xl flex flex-col justify-center items-center">
          <p className="text-2xl md:text-3xl lg:text-4xl">Prezentare</p>
        </div>
      </div>
      <div className="px-8 flex flex-col w-full items-center text-center mt-8 text-sm md:text-base lg:text-lg">
        <p className="text-2xl md:text-3xl lg:text-4xl font-bold">
          Novăcescu Adriana
        </p>
        <p className="text-lg md:text-xl lg:text-2xl font-bold">
          Logoped, Psiholog
        </p>
        <div className="mt-8 max-h-[32rem] aspect-1/1 overflow-hidden box-border p-4">
          <img
            className="w-full rounded-full"
            src="static/resources/Adriana-3.jpg"
            alt="Portret specialist"
          />
        </div>
        <p className="mt-8 text-base md:text-lg lg:text-xl font-bold pb-4">
          Experiență profesională:
        </p>
        <p className="leading-9">
          Practicant logopedie începând cu anul 2012 atât în mediul privat cât
          și în sistemul educațional de stat.
        </p>
        <p className="leading-9">Gradul didactic definitiv în învățământ.</p>
        <p className="leading-9">
          Specializare în dislalii și probleme de mobilitate oro-facială.
        </p>
        <p className="leading-9">Specializare în lucru cu copii.</p>
        <p className="leading-9">
          Adaptarea tehnicilor de educație cu empatie și blândețe în muncă și
          motivarea copiilor.
        </p>
        <p className="mt-8 text-base md:text-lg lg:text-xl font-bold pb-4">
          Studii:
        </p>
        <p className="leading-9">
          Diplomă de licență Facultatea de Sociologie și Psihologie,
          specializarea Psihologie, Universitatea de Vest, Timisoara
        </p>
        <p className="leading-9">
          Master Psihologie Clinică și Consiliere Phisologică, Universitatea de
          Vest, Timisoara
        </p>
        <p className="mt-8 text-base md:text-lg lg:text-xl font-bold pb-4">
          În formare:
        </p>
        <p className="mb-16 leading-9">Terapie mio-funcțională orofacială</p>
      </div>
    </div>
  );
};

export default Presentation;
